import { render, staticRenderFns } from "./RecognitionSettingsStep.vue?vue&type=template&id=8712ff72"
import script from "./RecognitionSettingsStep.vue?vue&type=script&lang=js"
export * from "./RecognitionSettingsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports